(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */
        (function () {
            var SHOWN_COOKIE = 'tg-leave-popup-shown';
            var HOT_OFFERS_SUBSCRIBE_SELECTOR = '.find-form-tab--hot-offers-subscribe';
            var COOKIE_MAX_AGE = 10 * 24 * 60 * 60;
            var content = document.getElementById('tgLeavePopupContent');

            if (!content) {
                return;
            }

            var config = parseConfig(content.dataset.config);
            var cityButtons = Array.from(content.querySelectorAll('.js_tg-leave-popup-city'));
            var starButtons = Array.from(content.querySelectorAll('.js_tg-leave-popup-star'));
            var minInput = content.querySelector('.js_tg-leave-popup-budget-min');
            var maxInput = content.querySelector('.js_tg-leave-popup-budget-max');
            var rangeRoot = content.querySelector('.js_tg-leave-popup-range');
            var minRange = content.querySelector('.js_tg-leave-popup-range-min');
            var maxRange = content.querySelector('.js_tg-leave-popup-range-max');
            var activeRange = content.querySelector('.js_tg-leave-popup-range-active');
            var submitButton = content.querySelector('.js_tg-leave-popup-btn');

            if (!minInput || !maxInput || !rangeRoot || !minRange || !maxRange || !activeRange || !submitButton) {
                return;
            }

            var state = {
                budgetMin: normalizeBudgetValue(config.defaultBudgetMin, 0, config.absoluteBudgetMax),
                budgetMax: normalizeBudgetValue(config.defaultBudgetMax, 0, config.absoluteBudgetMax)
            };
            var isOpeningRequested = false;
            var isSubmitRequestPending = false;
            var isProgrammaticSubmitClick = false;
            var requestCounter = 0;

            function parseConfig(rawConfig) {
                try {
                    return Object.assign({
                        requestUrl: '',
                        defaultBudgetMin: 0,
                        defaultBudgetMax: 500000,
                        absoluteBudgetMax: 2000000
                    }, JSON.parse(rawConfig || '{}'));
                } catch (e) {
                    return {
                        requestUrl: '',
                        defaultBudgetMin: 0,
                        defaultBudgetMax: 500000,
                        absoluteBudgetMax: 2000000
                    };
                }
            }

            function isMobile() {
                return Boolean(window.app && window.app.isMobile);
            }

            function isShown() {
                return Boolean(window.getCookieByName && window.getCookieByName(SHOWN_COOKIE));
            }

            function markShown() {
                document.cookie = SHOWN_COOKIE + '=1; max-age=' + COOKIE_MAX_AGE + '; path=/; SameSite=Lax';
            }

            function sendEvent(name) {
                if (window.brxTracking && typeof window.brxTracking.sendAnalyticsEvent === 'function') {
                    window.brxTracking.sendAnalyticsEvent(name);
                }
            }

            function setSubmitHref(url) {
                submitButton.setAttribute('href', url || '#');
            }

            function invalidateSubmitHref() {
                setSubmitHref('#');
            }

            function setSubmitLoading(isLoading) {
                submitButton.classList.toggle('loader-btn', isLoading);
            }

            function isModalOpen() {
                return Boolean(document.querySelector('.modal2.open'));
            }

            function openModal(isManualOpen) {
                if (!window.modal || typeof window.modal.open !== 'function' || !isManualOpen && isOpeningRequested || isModalOpen()) {
                    return;
                }

                isOpeningRequested = true;
                markShown();
                sendEvent('tg_subscribe_leave_open');
                window.modal.open({
                    header: null,
                    content: { htmlDetachSelectorId: 'tgLeavePopupContent' },
                    parentCssClass: 'tg-leave-popup-modal',
                    type: window.modal.types.FLOATING,
                    footer: null
                });
            }

            function normalizeBudgetValue(value, minValue, maxValue) {
                var normalizedValue = parseDigits(value);
                if (normalizedValue < minValue) {
                    return minValue;
                }
                if (normalizedValue > maxValue) {
                    return maxValue;
                }
                return normalizedValue;
            }

            function parseDigits(value) {
                var digits = String(value || '').replace(/[^\d]/g, '');
                return digits === '' ? 0 : parseInt(digits, 10);
            }

            function formatBudget(value) {
                return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            }

            function getPercent(value) {
                if (!config.absoluteBudgetMax) {
                    return 0;
                }

                return value / config.absoluteBudgetMax * 100;
            }

            function renderBudget() {
                minInput.value = formatBudget(state.budgetMin);
                maxInput.value = formatBudget(state.budgetMax);
                minRange.value = String(state.budgetMin);
                maxRange.value = String(state.budgetMax);

                activeRange.style.left = getPercent(state.budgetMin) + '%';
                activeRange.style.width = getPercent(state.budgetMax) - getPercent(state.budgetMin) + '%';
            }

            function setBudgetMin(value, keepRangeOrder) {
                var nextValue = normalizeBudgetValue(value, 0, state.budgetMax);
                state.budgetMin = keepRangeOrder ? nextValue : Math.min(nextValue, state.budgetMax);

                if (state.budgetMin > state.budgetMax) {
                    state.budgetMax = state.budgetMin;
                }

                renderBudget();
                invalidateSubmitHref();
            }

            function setBudgetMax(value, keepRangeOrder) {
                var nextValue = normalizeBudgetValue(value, state.budgetMin, config.absoluteBudgetMax);
                state.budgetMax = keepRangeOrder ? nextValue : Math.max(nextValue, state.budgetMin);

                if (state.budgetMax < state.budgetMin) {
                    state.budgetMin = state.budgetMax;
                }

                renderBudget();
                invalidateSubmitHref();
            }

            function handleBudgetInputTyping(input) {
                var digits = String(input.value || '').replace(/[^\d]/g, '');

                input.value = digits === '' ? '' : formatBudget(parseInt(digits, 10));
            }

            function commitBudgetMinInput() {
                var digits = parseDigits(minInput.value);
                setBudgetMin(digits, false);
            }

            function commitBudgetMaxInput() {
                var digits = parseDigits(maxInput.value);
                setBudgetMax(digits, false);
            }

            function getRangeStep() {
                var parsedStep = parseInt(minRange.step || maxRange.step || '1000', 10);

                return Number.isFinite(parsedStep) && parsedStep > 0 ? parsedStep : 1000;
            }

            function normalizeRangeClickValue(rawValue) {
                var step = getRangeStep();
                var snappedValue = Math.round(rawValue / step) * step;

                return normalizeBudgetValue(snappedValue, 0, config.absoluteBudgetMax);
            }

            function moveNearestThumb(clickedValue) {
                var minDistance = Math.abs(clickedValue - state.budgetMin);
                var maxDistance = Math.abs(clickedValue - state.budgetMax);

                if (minDistance <= maxDistance) {
                    setBudgetMin(clickedValue, false);
                    return;
                }

                setBudgetMax(clickedValue, false);
            }

            function selectCity(buttonToActivate) {
                cityButtons.forEach(function (button) {
                    button.classList.toggle('is-active', button === buttonToActivate);
                });

                invalidateSubmitHref();
            }

            function getSelectedStars() {
                return starButtons.filter(function (button) {
                    return button.classList.contains('is-active');
                }).map(function (button) {
                    return button.dataset.stars;
                }).sort(function (left, right) {
                    return parseInt(left, 10) - parseInt(right, 10);
                });
            }

            function getRequestParams() {
                return {
                    cityId: getSelectedCityId(),
                    stars: getSelectedStars(),
                    budgetMin: state.budgetMin,
                    budgetMax: state.budgetMax
                };
            }

            function getSelectedCityId() {
                var selectedButton = cityButtons.find(function (button) {
                    return button.classList.contains('is-active');
                });

                return selectedButton ? selectedButton.dataset.cityId || '' : '';
            }

            function requestTelegramUrl(onComplete) {
                if (!window.ajax || typeof window.ajax.post !== 'function') {
                    setSubmitLoading(false);
                    onComplete('');
                    return;
                }

                var currentRequestId = ++requestCounter;

                window.ajax.post(config.requestUrl, { params: getRequestParams() }, function (response) {
                    var redirectUrl = response && response.responseData ? response.responseData.url : '';

                    if (currentRequestId !== requestCounter) {
                        return;
                    }

                    setSubmitLoading(false);
                    if (!response || response.success !== true || !redirectUrl) {
                        onComplete('');
                        return;
                    }

                    setSubmitHref(redirectUrl);
                    onComplete(redirectUrl);
                });
            }

            cityButtons.forEach(function (button) {
                button.addEventListener('click', function () {
                    selectCity(button);
                });
            });

            starButtons.forEach(function (button) {
                button.addEventListener('click', function () {
                    button.classList.toggle('is-active');
                    invalidateSubmitHref();
                });
            });

            minRange.addEventListener('input', function () {
                setBudgetMin(minRange.value, false);
            });

            maxRange.addEventListener('input', function () {
                setBudgetMax(maxRange.value, false);
            });

            rangeRoot.addEventListener('click', function (event) {
                if (event.target === minRange || event.target === maxRange) {
                    return;
                }

                var rangeRect = rangeRoot.getBoundingClientRect();
                var clickRatio = rangeRect.width > 0 ? (event.clientX - rangeRect.left) / rangeRect.width : 0;
                var normalizedRatio = Math.min(Math.max(clickRatio, 0), 1);
                var clickedValue = normalizeRangeClickValue(normalizedRatio * config.absoluteBudgetMax);

                moveNearestThumb(clickedValue);
            });

            minInput.addEventListener('focus', function () {
                minInput.select();
            });

            maxInput.addEventListener('focus', function () {
                maxInput.select();
            });

            minInput.addEventListener('input', function () {
                handleBudgetInputTyping(minInput);
            });

            maxInput.addEventListener('input', function () {
                handleBudgetInputTyping(maxInput);
            });

            minInput.addEventListener('blur', function () {
                commitBudgetMinInput();
            });

            maxInput.addEventListener('blur', function () {
                commitBudgetMaxInput();
            });

            minInput.addEventListener('keydown', function (event) {
                if (event.key === 'Enter') {
                    commitBudgetMinInput();
                    minInput.blur();
                }
            });

            maxInput.addEventListener('keydown', function (event) {
                if (event.key === 'Enter') {
                    commitBudgetMaxInput();
                    maxInput.blur();
                }
            });

            submitButton.addEventListener('click', function (event) {
                if (isProgrammaticSubmitClick && submitButton.getAttribute('href') !== '#') {
                    isProgrammaticSubmitClick = false;
                    return;
                }

                event.preventDefault();
                if (isSubmitRequestPending) {
                    return;
                }

                sendEvent('tg_subscribe_leave_click');
                isSubmitRequestPending = true;
                setSubmitLoading(true);
                requestTelegramUrl(function (redirectUrl) {
                    isSubmitRequestPending = false;
                    if (!redirectUrl) {
                        return;
                    }

                    isProgrammaticSubmitClick = true;
                    submitButton.click();
                });
            });

            document.body.addEventListener('click', function (event) {
                var trigger = event.target.closest(HOT_OFFERS_SUBSCRIBE_SELECTOR);

                if (!trigger || isMobile()) {
                    return;
                }

                openModal(true);
            });

            document.body.addEventListener('mouseleave', function (event) {
                if (isMobile() || isShown()) {
                    return;
                }

                if (event.clientY >= 10) {
                    return;
                }

                openModal(false);
            });

            renderBudget();
            invalidateSubmitHref();
        })();
    }, {}] }, {}, [1]);